import { createState } from '~/src/hooks/useEoState'

export const MARKETPLACE_SEARCH_BUTTON_STATE = createState<boolean>({
  key: 'searchButtonState',
  default: false
})
